import { Component, OnInit, Input } from '@angular/core';
import { ValueAccessorBase } from '../../shared/value-accessor/value-accessor-base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SemDailyChallengeDialogComponent } from '../../dialogs/sem-daily-challenge-dialog/sem-daily-challenge-dialog.component';

@Component({
    selector: 'sem-daily-challenge',
    templateUrl: './sem-daily-challenge.component.html',
    styleUrls: ['./sem-daily-challenge.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemDailyChallengeComponent, multi: true }
    ],
    standalone: false
})
export class SemDailyChallengeComponent extends ValueAccessorBase<string> implements OnInit {

  @Input() settings: any;

  streakText = '3 dni zapored';
  progressCurrent = 1;
  progressTotal = 3;
  items = [
    { Label: 'Dodaj fotografijo k 5 zapisom', Done: true, Xp: 5 },
    { Label: 'Izpolni manjkajoča obvezna polja', Done: false, Xp: 10 },
    { Label: 'Poveži zapise z avtorjem', Done: false, Xp: 15 }
  ];
  footerActiveText = '3 aktivni ta teden';
  leaderboardLinkText = 'Lestvica →';

  get progressPct(): number {
    return this.progressTotal > 0 ? (this.progressCurrent / this.progressTotal) * 100 : 0;
  }

  ngOnInit() { }

  openDialog() {
    this.dialog.open(SemDailyChallengeDialogComponent, {
      panelClass: 'wg-daily-challenge-dialog'
    });
  }

}
